import { buildParser } from '@lezer/generator';

import { FunctionNameTokenizer, SimpleDialectTokenizer } from './tokens';

const formulaGrammar = `
  @skip { space }
  @tokens {
    @precedence {
      VariableName,
      String,
      Number
    }
    space { " " | "\\t" | "\\n" | "\\r" }

    hexDigit { $[0-9a-fA-F] }
    singleId { hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit hexDigit }
    fullId { singleId ( "_" singleId)* }
    identifier { $[a-zA-Z0-9_-]* ";"? }
    digit { $[0-9] }
    Number {
      "-"?((digit+ ("." digit+)?) | "." digit+)
    }
    String { '"' (!["\\\\] | "\\\\" _)* '"' }
    Operator { "+" | "-" | "*" | "/" | "<" | ">" | "=" | "!=" | "<=" | ">="  }


    tagVar { "tagId:" fullId }

    columnReference { "{colId:" ![}]+  "}"}
    variableIdentifier { "$$" identifier  | "@@" identifier | "&&" identifier }

    indexer { ("[" String "]" | "[" $[0-9]+ "]"  | "..")}

    variable { (variableIdentifier|columnReference) indexer* }

    date { digit digit digit digit "-" digit digit "-" digit digit }
    dateTime { date "T" digit digit ":" digit digit ":" digit digit "." digit+ "Z" }
    VariableName { variable | tagVar | dateTime | date  }
    Keyword { "true" | "false" }
  }
  @top Program { "="? Expression? }

  @external tokens FunctionNameTokenizer from "./tokens.js" { FunctionName }
  FunctionCall { FunctionName "(" (Expression ("," Expression)*)? ")"}
  Array { "[" (Expression ("," Expression)*)? "]" }
  SingleExpression { FunctionCall | VariableName | Number | String | Array |  Keyword }
  Expression { SingleExpression (Operator SingleExpression)* }
`;

const simpleGrammar = `
  @precedence {
    VariableName,
    Literal
  }
  @external tokens SimpleDialectTokenizer from "./tokens.js" { VariableName Literal }
  @top Program { UserInputSequence? }
  UserInputSequence { UserInputSequenceItem (UserInputSequenceItem)* }
  UserInputSequenceItem {  VariableName | Literal  }
`;

export const simpleParser = buildParser(simpleGrammar, {
  externalTokenizer: () => SimpleDialectTokenizer,
});
export const formulaParser = buildParser(formulaGrammar, {
  externalTokenizer: () => FunctionNameTokenizer,
});
